export const trendClass = (trend) => {
  if (trend === "increased") return "us-odds-value--up";
  if (trend === "decreased") return "us-odds-value--down";
  return "";
};

export const hasTrend = (trend) =>
  trend === "increased" || trend === "decreased";

